var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoneyBagCat15(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.031,
    height: 26.031,
    viewBox: "0 0 26.031 26.031",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "money_bag_24dp_E8EAED_FILL1_wght300_GRAD0_opsz24",
    d: "M153.013-801.256a2.659,2.659,0,0,1-1.954-.814,2.672,2.672,0,0,1-.812-1.957,2.66,2.66,0,0,1,.814-1.954,2.673,2.673,0,0,1,1.957-.811,2.659,2.659,0,0,1,1.954.814,2.672,2.672,0,0,1,.812,1.957,2.659,2.659,0,0,1-.814,1.954A2.672,2.672,0,0,1,153.013-801.256Zm-6.314-12.81h12.633l2.96-5.934H143.74Zm.981,20.1h10.672a7.423,7.423,0,0,0,5.44-2.231,7.4,7.4,0,0,0,2.24-5.455,7.654,7.654,0,0,0-.461-2.621,7.681,7.681,0,0,0-1.321-2.312l-4.32-5.183H146.1l-4.32,5.183a7.681,7.681,0,0,0-1.321,2.312,7.655,7.655,0,0,0-.461,2.621,7.419,7.419,0,0,0,2.231,5.455A7.413,7.413,0,0,0,147.68-793.968Z",
    transform: "translate(-140 820)",
    fill: "#85899c"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoneyBagCat15);
export default __webpack_public_path__ + "static/media/money_bag_cat_15.da2c57ce5171911d650943b2cc529d6b.svg";
export { ForwardRef as ReactComponent };